// extracted by mini-css-extract-plugin
export default {"formWrapper":"Forms_formWrapper__a4cxN"};